// extracted by mini-css-extract-plugin
export default {"uploadDragger":"SingleFileDragger_uploadDragger__TBx4A"};